import React, { useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, Typography, IconButton } from '@mui/material';
import { CalendarToday } from '@mui/icons-material';
import dayjs from 'dayjs';

export const CustomMinimalDatePicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);

  return (
    <Box display="flex" alignItems="center" gap={1}
      sx={{ bgcolor: "#ECECEC", py:1.2, px:2, borderRadius: 1 }}
    >
      <Typography
        variant="body2"
        sx={{
          color: value ? 'text.primary' : 'gray',
          
        }}
      >
        {value ? dayjs(value).format('YYYY-MM-DD') : 'YYYY-MM-DD'}
      </Typography>
      {/* <DatePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={value}
        onChange={(newValue) => {
          setOpen(false);
          onChange(newValue);
        }}
        minDate={dayjs().add(1, 'day')}
        renderInput={() => null}
        slotProps={{
          textField: {
            sx: { display: 'none' },

          },
        }}
      /> */}
      <DatePicker
  open={open}
  onClose={() => setOpen(false)}
  value={value}
  onChange={(newValue) => {
    setOpen(false);
    onChange(newValue);
  }}
  minDate={dayjs().add(1, 'day')}
  slotProps={{
    textField: {
      sx: {
        position: "absolute",
        opacity: 0,
        pointerEvents: "none",
        width: 0,
        height: 0,
      },
    },
  }}
/>

      <IconButton
        onClick={() => setOpen(true)}
        sx={{
          border: 'none',
          color: '#DC143C',
          bgcolor: "#fff",
          p:0.3,
          borderRadius:1,
          
          '&:hover': {
            bgcolor: '#fff',
          },
        }}
      >
        <CalendarToday />
      </IconButton>


    </Box>
  );
};
